const moduleMap = {
	"./automations": () => {
		return __webpack_require__.e(900).then(() => (() => ((__webpack_require__(2900)))));
	},
	"./createAutomations": () => {
		return __webpack_require__.e(820).then(() => (() => ((__webpack_require__(3820)))));
	},
	"./formCreateAutomations": () => {
		return __webpack_require__.e(267).then(() => (() => ((__webpack_require__(8267)))));
	},
	"./containerDetailAutomation": () => {
		return __webpack_require__.e(425).then(() => (() => ((__webpack_require__(4425)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});